var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GLYPH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48 48h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 48h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 48h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472 16h-432a24.0275 24.0275 0 0 0 -24 24v432a24.0275 24.0275 0 0 0 24 24h432a24.0275 24.0275 0 0 0 24-24v-432a24.0275 24.0275 0 0 0 -24-24zm8 32h-336v16h336v408a8.00917 8.00917 0 0 1 -8 8h-432a8.00917 8.00917 0 0 1 -8-8v-432a8.00917 8.00917 0 0 1 8-8h432a8.00917 8.00917 0 0 1 8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 96h176v16h-176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 168v48a8.00008 8.00008 0 0 0 8 8h252.67969l-13.46485 56h-239.21484a8.00008 8.00008 0 0 0 -8 8v48a8.00008 8.00008 0 0 0 8 8h368a8.00008 8.00008 0 0 0 8-8v-48a8.00008 8.00008 0 0 0 -8-8h-47.78418l-5.96973-16.24951 22.6084-2.43018a7.99953 7.99953 0 0 0 3.86328-14.41455l-31.36621-22.90576h58.64844a8.00008 8.00008 0 0 0 8-8v-48a8.00008 8.00008 0 0 0 -8-8h-368a8.00008 8.00008 0 0 0 -8 8zm310.34961 80.937a7.99994 7.99994 0 0 0 -6.65527 10.7124l19.31054 52.56543-15.01855 5.51709-19.30957-52.56492a8.00009 8.00009 0 0 0 -12.00684-3.85791l-10.166 6.91065 12.58593-52.34912 43.48145 31.75293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 128h72v16h-72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 248h112v16h-112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 368h112v16h-112z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 64,
    rx: 8,
    width: 384,
    x: 64,
    y: 400
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.b911b5ab.svg";
export { ForwardRef as ReactComponent };